/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import DatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import { addAttachments } from '@/app/services/students/students';
import * as Actions from '@/app/store/actions/';
import { getImageUrl, isSafari } from '@/utils/utils';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';

const AttachmentModal = ({ refreshAttachments, id }) => {
	const inputRef = useRef(null);
	const dispatch = useDispatch();
	const [data, setData] = useState({ file: null, category: null, expiry_date: null });
	const [loading, setLoading] = useState(false);
	const [category, setCategory] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);
	const handleDropFile = (file) => {
		if (file[0].name.split('.')[1] !== 'pdf') {
			dispatch(
				Actions.showMessage({
					message: 'Only PDF file allowed',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}
		if (file[0].size > 20000000) {
			dispatch(
				Actions.showMessage({
					message: 'File size must be less than 20 MB',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}
		setSelectedFile(file[0]);
	};
	const onSelectFile = (e) => {
		if (e.target.files[0].name.split('.')[1] !== 'pdf') {
			dispatch(
				Actions.showMessage({
					message: 'Only PDF file allowed',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}
		if (e.target.files[0].size > 20000000) {
			dispatch(
				Actions.showMessage({
					message: 'File size must be less than 20 MB',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}
		setSelectedFile(e.target.files[0]);
	};

	const handleSubmit = async () => {
		if (!selectedFile) {
			dispatch(
				Actions.showMessage({
					message: 'File is required',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}
		if (!data.category) {
			dispatch(
				Actions.showMessage({
					message: 'Category is required',
					variant: 'error',
					anchorOrigin: {
						vertical: isSafari() ? 'bottom' : 'top',
						horizontal: 'center',
					},
				}),
			);
			return;
		}

		const filename = getImageUrl(selectedFile);
		setLoading(true);
		uploadFile(selectedFile, filename)
			.then((url) => {
				const file = `${import.meta.env.VITE_S3_BASE_URL}${url}`;
				const payload = {
					file,
					name: selectedFile.name,
					file_type: 'pdf',
					student_id: id,
					category: data.category,
					expiry_date: data.expiry_date,
				};
				addAttachments(payload)
					.then(() => {
						dispatch(Actions.closeDialog());
						refreshAttachments();
					})
					.catch((err) => console.log(err))
					.finally(() => setLoading(false));
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to upload image',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
				setLoading(false);
			});
	};

	return (
		<div className="">
			<div className="flex justify-between items-center mb-32">
				<p className="text-pd-xl" style={{ fontWeight: '700' }}>
					Upload Attachment
				</p>
			</div>
			{selectedFile ? (
				<div className="flex items-center justify-center relative attachment-file-div">
					<img
						alt=""
						className="cursor-pointer self-center"
						src="assets/images/pdf_thumbnail.png"
						style={{ width: '80px', height: '80px' }}
					/>
				</div>
			) : (
				<Dropzone multiple={false} onDrop={handleDropFile}>
					{({ getRootProps }) => (
						<div {...getRootProps({ className: 'dropzone' })}>
							<div className="fileUpload-div">
								<div className="cloud-div">
									<div className="cloud" onClick={() => inputRef.current.click()}>
										<img alt="computer" height="20%" src="assets/images/cloud.svg" width="20%" />
									</div>
									<input
										accept=".pdf"
										className="hidden"
										id="fileSelect"
										name="fileSelect"
										onChange={onSelectFile}
										ref={inputRef}
										type="file"
									/>
									<p className="hidden sm:block">Drag & drop your file here</p>
									<span className="hidden sm:block">OR</span>
									<div
										className="mt-20 sm:mt-0"
										style={{
											justifyContent: 'center',
											alignSelf: 'center',
											display: 'flex',
											width: '100%',
										}}
									>
										<CustomButton
											fontSize="15px"
											height="40px"
											marginTop={10}
											onClick={() => inputRef.current.click()}
											type="file"
											variant="primary"
											width="150px"
										>
											Browse Files
										</CustomButton>
									</div>
								</div>
							</div>
						</div>
					)}
				</Dropzone>
			)}
			<div className="room-attach flex justify-between flex-col gap-16">
				<FormControl className="w-full student-select" variant="standard">
					<InputLabel id="categoryLabel">Select Category</InputLabel>
					<Select
						id="category"
						label="Select Category"
						labelId="categoryLabel"
						name="category"
						onChange={(e) => {
							const { value } = e.target;
							setCategory(value);
							setData({ ...data, category: value });
						}}
						value={category}
					>
						<MenuItem value="Medical Form">Medical Form</MenuItem>
						<MenuItem value="EpiPen Form">EpiPen Form</MenuItem>
						<MenuItem value="Court documents">Court documents</MenuItem>
						<MenuItem value="Student Health Records">Student Health Records</MenuItem>
						<MenuItem value="Immunization Document">Immunization Document</MenuItem>
						<MenuItem value="Medication permission form">Medication permission form </MenuItem>
						<MenuItem value="Distracted Adult">Distracted Adult</MenuItem>
						<MenuItem value="Influenza Brochure">Influenza Brochure</MenuItem>
						<MenuItem value="Enrollment Agreement">Enrollment Agreement</MenuItem>
						<MenuItem value="Enrollment Application">Enrollment Application</MenuItem>
						<MenuItem value="Other">Other</MenuItem>
					</Select>
				</FormControl>

				<DatePicker
					className="date-picker-width"
					disablePast
					label="Expiry date"
					setValue={(date) => setData({ ...data, expiry_date: date ? date.format('YYYY-MM-DD') : null })}
					value={data.expiry_date}
				/>
			</div>
			{category === 'Other' ? (
				<TextField
					className="w-5/12 mt-16"
					label="Category"
					name="category"
					onChange={(e) => setData({ ...data, category: e.target.value })}
					value={data.category || ''}
				/>
			) : null}
			<div className="flex justify-center mt-24 pb-20">
				{loading ? (
					<CircularProgress size={35} />
				) : (
					<CustomButton onClick={handleSubmit} variant="primary" width={150}>
						Done
					</CustomButton>
				)}
			</div>
		</div>
	);
};

export default AttachmentModal;
